import React from "react"

import { Checkbox } from "@mui/material"
import { makeStyles } from "@mui/styles"
import T from "prop-types"

import { Data } from "@cirrus/fe-lib"

import { Palette } from "../../../lib/_private"
import { FormControlLabel } from "../../mui-reexports"

export const useControlOverrides = makeStyles(({ withPalette }) => ({
  root: ({ color, disabled }) => ({
    "&.MuiCheckbox-root": {
      "&[class*='Mui-checked']": {
        color: withPalette(color, Palette.isSecondary(color) ? "contrastText" : "main"),
      },
      color: disabled ? "#bdbdbd" : "#757575",
    },
  }),
}))

export const useLabelOverrides = makeStyles(({ typography }) => ({
  label: ({ disabled }) => ({
    "&.MuiTypography-root": {
      color: disabled ? "#bdbdbd" : typography.color,
      fontSize: typography.pxToRem(14),
      fontWeight: 700,
    },
    alignItems: "center",
    display: "flex",
  }),

  root: {
    alignItems: "stretch",
    marginBottom: 0,
    width: "fit-content",
  },
}))

export const LabeledCheckbox = ({ color = "primary", disabled, label, dataQa, ...props }) => {
  const formControlClasses = useLabelOverrides({ disabled })
  const checkboxClasses = useControlOverrides({ color, disabled })
  const checkboxProps = Data.merged(props, {
    classes: checkboxClasses,
    color: "default",
  })

  if (!label) {
    return <Checkbox {...checkboxProps} disabled={disabled} />
  }

  return (
    <FormControlLabel
      data-qa={dataQa}
      classes={formControlClasses}
      control={<Checkbox {...checkboxProps} disabled={disabled} />}
      label={label}
    />
  )
}

LabeledCheckbox.propTypes = {
  checked: T.bool,
  className: T.string,
  color: T.string,
  disabled: T.bool,
  label: T.string,
  onChange: T.func,
  size: T.oneOf(["medium", "small"]),
  value: T.any,
}
